import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './pages/home/Home';
import Locations from './pages/locations/Locations';
import AboutUs from './pages/aboutUs/AboutUs';
import ContactUs from './pages/contactUs/ContactUs';
import MyBooking from './pages/myBooking/MyBooking';
import { WebDataProvider } from './context/WebDataProvider';
import { ActiveNavBarProvider } from './context/ActiveNavbarProvider';
import Terms from './pages/terms/Terms';
import Blog from './pages/blog/Blog';
import Fleet from './pages/fleet/Fleet';
import Clients from './pages/clients/Clients';
import FAQ from './pages/faq/FAQ';
import { ConfirmProvider } from './context/ConfirmProvider';
import { Reservation } from './pages/reservation/Reservation';
import CorporateTransport from './pages/blog/CorporateTransport';
import EventVanTravel from './pages/blog/EventVanTravel';
import AirportVanRental from './pages/blog/AirportVanRental';
import VanComfort from './pages/blog/VanComfort';
import VanPickup from './pages/blog/VanPickup';
import GroupTravel from './pages/blog/GroupTravel';
import GroupRoadTrip from './pages/blog/GroupRoadTrip';
import ConferenceTransport from './pages/blog/ConferenceTransport';
import ScrollToTop from './components/ScrollToTop';
import { TopBar } from './components/TopBar';
import { ReservationProvider } from './context/ReservationProvider';
import { PleasWaitProvider } from './context/PleaseWaitProvider';
import { ConfirmPopup } from './components/ConfirmPopup';
import { PleaseWaitPopup } from './components/PleaseWaitPopup';
import { RedirectOnRefresh } from './pages/home/RedirectOnRefresh';
import { ReservationFormProvider } from './context/ReservationFormProvider';
import { UpdateReservationForm } from './components/UpdateReservationForm';
import { VehicleEnquiryProvider } from './context/VehicleEnquiryProvider';
import { VehicleEnquiryPopup } from './components/VehicleEnquiryPopup';
import { QuotesPopupProvider } from './context/QuotesPopupProvider';
import { QuotePopup } from './components/QuotePopup';
import { PrintQuotes } from './pages/PrintQuotes';
import CustomerPaymentRequestView from './pages/public/booking/CustomerPaymentRequestView';
import RentalAgreementView from './pages/public/booking/RentalAgreementView';
import ViewBooking from './pages/public/booking/ViewBooking';
import TroubleErrorPage from './pages/public/booking/TroubleErrorPage';
import { OpeningHours } from './pages/OpeningHours';
import PageNotFound from './pages/PageNotFound';
import LocationTroubleErrorPage from './pages/public/share-location/LocationTroubleErrorPage';
import ShareLocation from './pages/public/share-location/ShareLocation';

function App() {

  return (
    <Router>
      <PleasWaitProvider>
        <WebDataProvider>
          <ConfirmProvider>
            <ReservationProvider>
              <ScrollToTop />
              <ActiveNavBarProvider>
                <QuotesPopupProvider>
                  <ReservationFormProvider>
                    <VehicleEnquiryProvider>
                      <TopBar />
                      <RedirectOnRefresh />
                      <Routes>
                        <Route path="*" element={<PageNotFound />} />
                        <Route path="not-found" element={<PageNotFound />} />
                        <Route path="/" element={<Home />} />
                        <Route path="/reservation" element={<Reservation />} />
                        <Route path='/about-us' element={<AboutUs />} />
                        <Route path='/terms' element={<Terms />} />
                        <Route path='/locations' element={<Locations />} />
                        <Route path='/blog' element={<Blog />} />
                        <Route path="/blog/corporate-transport" element={<CorporateTransport />} />
                        <Route path="/blog/event-van-travel" element={<EventVanTravel />} />
                        <Route path="/blog/airport-van-travel" element={<AirportVanRental />} />
                        <Route path="/blog/van-comfort" element={<VanComfort />} />
                        <Route path="/blog/van-pickup" element={<VanPickup />} />
                        <Route path="/blog/group-travel" element={<GroupTravel />} />
                        <Route path="/blog/group-road-trip" element={<GroupRoadTrip />} />
                        <Route path="/blog/conference-transport" element={<ConferenceTransport />} />
                        <Route path='/fleet' element={<Fleet />} />
                        <Route path='/opening-hours' element={<OpeningHours />} />
                        <Route path='/clients' element={<Clients />} />
                        <Route path='/faq' element={<FAQ />} />
                        <Route path='/contact-us' element={<ContactUs />} />
                        <Route path='/my-booking' element={<MyBooking />} />


                        {/* Public Routes */}
                        <Route path="public">
                          <Route path="booking">
                            <Route index element={<CustomerPaymentRequestView />} />
                            <Route path="rental-agreement" element={<RentalAgreementView />} />
                            <Route path="view-booking" element={<ViewBooking />} />
                            <Route path="not-available" element={<TroubleErrorPage />} />
                          </Route>

                          <Route path="share-location">
                            <Route index element={<ShareLocation />} />
                            <Route path="not-available" element={<LocationTroubleErrorPage />} />
                          </Route>
                        </Route>

                        {/* Print view */}
                        <Route path='/carrental/reservations/print-quote' element={<PrintQuotes />} />
                      </Routes>
                      <ConfirmPopup />
                      <QuotePopup />
                      <UpdateReservationForm />
                      <VehicleEnquiryPopup />
                    </VehicleEnquiryProvider>
                    <PleaseWaitPopup />
                    <Footer />
                  </ReservationFormProvider>
                </QuotesPopupProvider>
              </ActiveNavBarProvider>
            </ReservationProvider>
          </ConfirmProvider>
        </WebDataProvider>
      </PleasWaitProvider>
    </Router>
  );
}

export default App;
